export const TITLE_SUFFIX = 'Eventum';

export const TITLE_GENERIC = 'Eventum';

